/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CircleCrossIcon - Auto-generated from icon.js
 */
export const CircleCrossIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM10.2949 9.61543C10.4672 9.78496 10.4699 10.0611 10.3017 10.2348C10.1322 10.407 9.85602 10.4098 9.68239 10.2416L6.99997 7.6125L4.31755 10.2402C4.14528 10.4098 3.86774 10.407 3.69821 10.2334C3.52868 10.0611 3.53141 9.78359 3.70505 9.61406L6.37516 7L3.70505 4.38457C3.53278 4.21504 3.53005 3.93887 3.69821 3.76523C3.86774 3.59297 4.14391 3.59023 4.31755 3.7584L6.99997 6.3875L9.68239 3.75977C9.85465 3.59023 10.1322 3.59297 10.3017 3.7666C10.4713 3.93887 10.4685 4.21641 10.2949 4.38594L7.62477 7L10.2949 9.61543Z"
			fill="current"
		/>
	</svg>
);

export default CircleCrossIcon;
